module.exports = __webpack_public_path__ + "static/img/r1.9795dd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/r1.png
// module id = 8t9N
// module chunks = 0